import React from 'react';
import { Card, Heading, Pane, Text } from 'evergreen-ui';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip as ChartTooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, ChartTooltip, Legend);

// Helper to generate random colors for the pie chart
const getRandomColor = () => {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgba(${r}, ${g}, ${b}, 0.6)`;
};

const RevenueByRegionPieChart = ({ data, currencySymbol }) => {
    if (!data || data.length === 0) {
        // Don't render anything if there's no data, or a message if needed elsewhere
        return null;
    }

    const chartData = {
        labels: data.map(item => item.region?.name || 'Rest of World'),
        datasets: [
            {
                label: 'Revenue by Region',
                data: data.map(item => item.totalRevenue),
                backgroundColor: data.map(() => getRandomColor()),
                borderColor: data.map(() => 'rgba(255, 255, 255, 1)'),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed !== null) {
                            label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol' }).format(context.parsed).replace('$', currencySymbol);
                        }
                        return label;
                    }
                }
            }
        },
    };

    return (
        <Card flex={1} padding={16} background="tint1" elevation={1} marginLeft={24}>
            <Heading size={500} marginBottom={16}>
                Revenue Distribution by Region
            </Heading>
            <Pane height={300}> {/* Ensure chart has a defined height */}
                <Pie data={chartData} options={options} />
            </Pane>
        </Card>
    );
};

export default RevenueByRegionPieChart;
